import api from "@/api";

const namespaced = true;

const state = {
  fuelOptimization: {}
}

const getters = {
  fuelOptimization: state => state.fuelOptimization
}

const mutations = {
  SET_FUEL_OPTIMIZATION: (state, payload) => {
    state.fuelOptimization = payload;
  }
}

const actions = {
  async fetchFuelOptimization({ commit }, payload) {
    try {
      const { data } = await api.getFuelOptimizationKpi(payload)

      if (data.error) {
        commit('SET_FUEL_OPTIMIZATION', null)
        return
      }

      commit('SET_FUEL_OPTIMIZATION', data)
    } catch (error) {
      throw error;
    }
  }
}

export default { namespaced, state, getters, mutations, actions }